export default function getLabelByValue(obj, value){
    let filtered = Object.entries(obj).find(x=>{
        return x[1] == value;
    });
    if(filtered && filtered.length > 0){
        return filtered[0];
    }
    return '';
}